import { Tooltip, TooltipProps } from '@mui/material';

// The GravyWorkers design draws every hover tip as a white card with a grey
// border and dark text that wraps to two lines, not MUI's default dark
// one-line bubble (design vs implemented L1). The colours match the
// HeaderTooltip surface on the same page.
const tooltipSx = {
  backgroundColor: '#FFFFFF',
  color: '#1C1C1C',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.12)',
  padding: '10px 14px',
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: 1.45,
  maxWidth: '200px',
};
const arrowSx = {
  color: '#FFFFFF',
  '&::before': { border: '1px solid #DADADA' },
};

const CardTooltip = ({ children, ...props }: TooltipProps) => (
  <Tooltip
    arrow
    {...props}
    componentsProps={{
      tooltip: { sx: tooltipSx, 'data-testid': 'cardTooltip' } as object,
      arrow: { sx: arrowSx },
    }}
  >
    {children}
  </Tooltip>
);

export default CardTooltip;
